import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf8a534a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "contractLaborRequestSingleDaySection" }
const _hoisted_2 = {
  key: 0,
  id: "contract-labor-management-modal-content-loading",
  class: "loadingDiv1",
  style: {"padding":"5px"}
}
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = { class: "fa-2x" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Processing...")
], -1))
const _hoisted_6 = {
  id: "contractLaborRequestSingleDayView",
  class: "txtLeft"
}
const _hoisted_7 = { class: "row rowSingleDay mb-3" }
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "facility", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "department", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "date", -1))
const _hoisted_16 = { class: "col-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "shift", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "skill", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "row rowSingleDay mb-3" }
const _hoisted_23 = { class: "col-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "specialization", -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "col-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "number of resources", -1))
const _hoisted_28 = { class: "col-4" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "notes", -1))
const _hoisted_30 = {
  class: "col-2 search-wrapper",
  style: {"padding-top":"20px","padding-left":"0"}
}
const _hoisted_31 = { class: "row rowSingleDay" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "assignment-list ms-1 me-1" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Request Confirmation ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Activity Log ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Manage Contract ", -1))
const _hoisted_37 = {
  key: 0,
  id: "singleDayRequestConfirmationTabContent",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "vertical-center" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = {
  class: "col-md-3 fa-xl",
  style: {"text-align":"right"}
}
const _hoisted_42 = {
  class: "col-md-9",
  style: {"text-align":"left"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Automation has been enabled for this Department. Manual submissions are not allowed at this time.", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 0,
  class: "row singleDayNoRequestHeading"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col d-flex justify-content-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "No requests submitted. Please request one above.")
], -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 1,
  id: "singleDayRequestConfirmarionContainer"
}
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col d-flex justify-content-center mt-2" }
const _hoisted_52 = { class: "h3" }
const _hoisted_53 = { class: "requestConfirmationResourceCount" }
const _hoisted_54 = { class: "row mb-4" }
const _hoisted_55 = { class: "col-md-4" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col col-form-label font-weight-bold" }, "Facility", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = {
  class: "col col-form-label",
  id: "requestConfirmationFacility"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-2 col-form-label font-weight-bold" }, "Dept", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_63 = {
  class: "col col-form-label",
  id: "requestConfirmationDepartment"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = { class: "col-md-4" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-2 col-form-label font-weight-bold" }, "Shift", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = {
  class: "col col-form-label",
  id: "requestConfirmationShift"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_70 = { class: "row mb-4" }
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-2 col-form-label font-weight-bold" }, "Date", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_74 = {
  class: "col col-form-label",
  id: "requestConfirmationDate"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = { class: "col-md-4" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-2 col-form-label font-weight-bold" }, "Skill", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_79 = {
  class: "col col-form-label",
  id: "requestConfirmationSkill"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = { class: "col-md-4" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-2 col-form-label font-weight-bold" }, "Specialization", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_84 = {
  class: "col col-form-label",
  id: "requestConfirmationSpecialization"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_86 = { class: "row" }
const _hoisted_87 = { class: "col-md-12" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-2 col-form-label font-weight-bold" }, "Notes", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_90 = {
  class: "col col-form-label",
  id: "requestConfirmationNotes"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_92 = { class: "row mt-6" }
const _hoisted_93 = { class: "col d-flex justify-content-center mt-5" }
const _hoisted_94 = {
  key: 1,
  id: "singleDayMyRecentActivityTabContent",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_95 = {
  key: 1,
  id: "period-message-text"
}
const _hoisted_96 = {
  key: 2,
  id: "singleDayManageContractTabContent",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_98 = { class: "col" }
const _hoisted_99 = ["href"]
const _hoisted_100 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_neu_input = _resolveComponent("neu-input")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_neu_tab = _resolveComponent("neu-tab")!
  const _component_neu_tablist = _resolveComponent("neu-tablist")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_neu_paginator = _resolveComponent("neu-paginator")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_neu_table_row_count = _resolveComponent("neu-table-row-count")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_neu_container = _resolveComponent("neu-container")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isShowContractLaborLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_font_awesome_icon, {
                  spin: true,
                  icon: ['fas', 'circle-notch'],
                  size: "lg"
                })
              ]),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isFacilityError ? 'hasError': '']]),
              name: "facility",
              id: "singleDayFacilityDDL",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFacility) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFacilityChange && _ctx.onFacilityChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilities, (fac) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fac.Value,
                  key: fac.Value
                }, _toDisplayString(fac.Text), 9, _hoisted_10))
              }), 128))
            ], 34), [
              [_vModelSelect, _ctx.selectedFacility]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isFacilityError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isDepartmentError ? 'hasError': '']]),
              name: "department",
              id: "singleDayDepartmentDDL",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDepartment) = $event)),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDepartmentChange && _ctx.onDepartmentChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (dept) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: dept.Value,
                  key: dept.Value
                }, _toDisplayString(dept.Text), 9, _hoisted_13))
              }), 128))
            ], 34), [
              [_vModelSelect, _ctx.selectedDepartment]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isDepartmentError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.requestDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDate) = $event)),
              weekStart: "0",
              inputClassName: "dp-custom-input",
              class: _normalizeClass(["form-control requestDate", [_ctx.isRequestDateError ? 'hasError': '']]),
              style: {"width":"100%"},
              enableTimePicker: false,
              autoApply: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.isRequestDateError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true",
                  style: {"top":"2.2rem !important"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isShiftError ? 'hasError': '']]),
              name: "shift",
              id: "singleDayShiftsDDL",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedShift) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shifts, (shft) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: shft.deptShiftId,
                  key: shft.deptShiftId
                }, _toDisplayString(shft.deptShiftDescription), 9, _hoisted_18))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.selectedShift]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isShiftError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isSkillError ? 'hasError': '']]),
              name: "skill",
              id: "singleDaySkill",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedSkill) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skl) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: skl.skillLevelId,
                  key: skl.skillLevelId
                }, _toDisplayString(skl.description), 9, _hoisted_21))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.selectedSkill]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isSkillError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isSpecializationError ? 'hasError': '']]),
              name: "skillSpecialization",
              id: "singleDaySpecialization",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedSkillSpecialization) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillSpecializations, (fac) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fac.wfFoldergroupID,
                  key: fac.wfFoldergroupID
                }, _toDisplayString(fac.wfFolderGroupName), 9, _hoisted_25))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.selectedSkillSpecialization]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isSpecializationError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_neu_input, {
              id: "resource-count",
              modelValue: _ctx.resourceCount,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.resourceCount) = $event)),
              class: _normalizeClass([_ctx.isResourcesCountError ? 'hasError': ''])
            }, null, 8, ["modelValue", "class"]),
            (_ctx.isResourcesCountError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode(_component_neu_input, {
              id: "notes",
              modelValue: _ctx.notes,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.notes) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_neu_button, {
              type: "button",
              fill: "raised",
              disabled: _ctx.isDisableCreateRequest,
              id: "WFRequestStatusSearch",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isDisableCreateRequest ? null : _ctx.searchClick()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SUBMIT REQUEST ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_neu_tablist, {
              value: _ctx.selectedTab,
              class: "mx-4 tabList txtLeft"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_tab, {
                  white: "",
                  tab: "RequestConfirmationTab",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setSelectedTab('RequestConfirmationTab')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_34
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_tab, {
                  white: "",
                  tab: "ActivityLogTab",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setSelectedTab('ActivityLogTab')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_tab, {
                  white: "",
                  tab: "ManageContractTab",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setSelectedTab('ManageContractTab')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            (_ctx.isRequestConfirmationVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  (_ctx.isContractLaborNeedAutomationEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fas', 'warning'],
                                size: "2xl",
                                style: {"color":"red"}
                              })
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _hoisted_43,
                              _hoisted_44,
                              _createElementVNode("span", null, [
                                _createTextVNode("Use the WF Automation Status Tool by "),
                                _createElementVNode("span", {
                                  class: "clickSpan",
                                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showWorkforceRequestStatusPopup && _ctx.showWorkforceRequestStatusPopup(...args)))
                                }, "Clicking here"),
                                _createTextVNode(" to see Automation activity for this department.")
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        (_ctx.isShowSingleDayNoRequestHeading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_48))
                          : _createCommentVNode("", true),
                        (_ctx.isShowSingleDayRequestConfirmarion)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createTextVNode(" Resource Count "),
                                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.requestConfirmationResourceCount), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  _hoisted_56,
                                  _hoisted_57,
                                  _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.requestConfirmationFacility), 1),
                                  _hoisted_59
                                ]),
                                _createElementVNode("div", _hoisted_60, [
                                  _hoisted_61,
                                  _hoisted_62,
                                  _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.requestConfirmationDepartment), 1),
                                  _hoisted_64
                                ]),
                                _createElementVNode("div", _hoisted_65, [
                                  _hoisted_66,
                                  _hoisted_67,
                                  _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.requestConfirmationShift), 1),
                                  _hoisted_69
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("div", _hoisted_71, [
                                  _hoisted_72,
                                  _hoisted_73,
                                  _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.requestConfirmationDate), 1),
                                  _hoisted_75
                                ]),
                                _createElementVNode("div", _hoisted_76, [
                                  _hoisted_77,
                                  _hoisted_78,
                                  _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.requestConfirmationSkill), 1),
                                  _hoisted_80
                                ]),
                                _createElementVNode("div", _hoisted_81, [
                                  _hoisted_82,
                                  _hoisted_83,
                                  _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.requestConfirmationSpecialization), 1),
                                  _hoisted_85
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("div", _hoisted_87, [
                                  _hoisted_88,
                                  _hoisted_89,
                                  _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.requestConfirmationNotes), 1),
                                  _hoisted_91
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("div", _hoisted_93, [
                                  _createVNode(_component_neu_button, {
                                    type: "button",
                                    fill: "raised",
                                    id: "singleDayCancelRequest",
                                    onClick: _ctx.onCancelRequests
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" CANCEL SUBMITTED REQUESTS ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isActivityLogVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                  _createVNode(_component_neu_card, {
                    color: "plain-0",
                    class: "p-0 m-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_neu_table, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_table_row, {
                            columns: _ctx.columnHeaders,
                            header: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                                return (_openBlock(), _createBlock(_component_neu_table_heading, {
                                  key: column,
                                  icon: _ctx.columnIcons[column],
                                  slot: column,
                                  style: {"padding-top":"25px !important"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(column), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["icon", "slot"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["columns"]),
                          _createVNode(_component_neu_table_body, { align: "left" }, {
                            default: _withCtx(() => [
                              (_ctx.activityLogGridData != null && _ctx.activityLogGridData.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.activityLogGridData, (activityLog) => {
                                    return (_openBlock(), _createBlock(_component_neu_table_row, {
                                      columns: _ctx.columnHeaders,
                                      key: activityLog,
                                      slot: _ctx.column
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_neu_label, {
                                          slot: "Requested At",
                                          title: activityLog.createdDate
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.createdDate), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Action",
                                          title: activityLog.transactionName
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.transactionName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Facility",
                                          title: activityLog.facilityName
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.facilityName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Department",
                                          title: activityLog.departmentName
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.departmentName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Skill",
                                          title: activityLog.skill
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.skill), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Requested For",
                                          title: activityLog.requestedForDate
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.requestedForDate), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "User",
                                          title: activityLog.userInfo
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.userInfo), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Details",
                                          title: activityLog.details
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.details), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"])
                                      ]),
                                      _: 2
                                    }, 1032, ["columns", "slot"]))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("p", _hoisted_95, "No data available on current page."))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.activityLogGridData != null && _ctx.activityLogGridData.length > 0)
                    ? (_openBlock(), _createBlock(_component_neu_container, {
                        key: 0,
                        fluid: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_neu_col, {
                                md: "6",
                                cols: "12",
                                class: "neu-text-center neu-text-md-left"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_neu_paginator, {
                                    class: "justify-content-start",
                                    onVNeuChange: _cache[15] || (_cache[15] = (ev) => this.pageNum = ev.detail.pageNumber),
                                    total: _ctx.activityLogGridData != null && _ctx.activityLogGridData.length,
                                    rowsPerPage: _ctx.rowsPerPage
                                  }, null, 8, ["total", "rowsPerPage"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_neu_col, {
                                md: "6",
                                cols: "12",
                                class: "neu-text-center neu-text-md-right"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_neu_table_row_count, {
                                    class: "mt-3",
                                    section: "number",
                                    total: _ctx.activityLogGridData != null && _ctx.activityLogGridData.length,
                                    "page-number": _ctx.pageNum,
                                    onVNeuChange: _ctx.rowCountChange
                                  }, null, 8, ["total", "page-number", "onVNeuChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isManageContractVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _hoisted_97,
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("a", {
                      id: "manage-contract-labor-lnk",
                      class: "mr-1",
                      href: _ctx.contractLaborLink,
                      target: "_blank"
                    }, " Manage Contract Labor", 8, _hoisted_99)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}